import React from "react";

const HandRaised = (props: { className?: string }) => (
  <svg
    width="55"
    height="67"
    viewBox="0 0 55 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || ""}
  >
    <g id="hand raised 1" clipPath="url(#clip0_21_5026)">
      <path
        id="Vector"
        d="M54.987 17.5492C54.987 13.743 55.0224 9.93671 54.9758 6.13145C54.9273 2.20046 51.2126 -0.671305 47.3036 0.136472C44.3005 0.757154 42.2307 3.24879 42.2276 6.28885C42.2195 13.5727 42.2286 20.8575 42.2185 28.1414C42.2185 28.4948 42.1467 28.867 42.0201 29.1977C40.2569 33.7958 38.4705 38.3861 36.7164 42.9873C36.5393 43.4525 36.3308 43.6139 35.8095 43.6129C27.3934 43.5931 18.9772 43.5951 10.5611 43.5991C4.5731 43.603 0.0102589 48.0587 0.00317378 53.8992C-0.000874881 57.5233 0.000137284 61.1474 0.00114945 64.7705C0.00114945 66.2158 0.755212 66.988 2.21678 66.989C9.14302 66.9969 16.0693 66.9919 22.9955 66.9919V66.9989C29.8479 66.9989 36.6992 66.9989 43.5515 66.9989C45.2732 66.9989 45.9767 66.3 45.9757 64.6003C45.9757 61.6503 45.9909 58.7003 45.9635 55.7504C45.9544 54.7585 46.1073 53.8448 46.4797 52.8994C49.165 46.0749 51.7845 39.2256 54.4384 32.3892C54.8139 31.421 54.9951 30.439 54.992 29.4036C54.9779 25.4518 54.988 21.5 54.988 17.5482L54.987 17.5492Z"
        fill="#1E1BAF"
      />
      <path
        id="Vector_2"
        d="M22.875 40.7264C31.1717 40.7383 37.8419 34.2781 37.85 26.2231C37.8581 18.2205 31.1919 11.6959 23.0025 11.691C14.808 11.686 8.15508 18.1878 8.14698 26.2082C8.13888 34.183 14.7645 40.7145 22.875 40.7264Z"
        fill="#1E1BAF"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_5026">
        <rect width="55" height="67" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default HandRaised;
